"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _preactPortal = _interopRequireDefault(require("preact-portal"));

var _Close = _interopRequireDefault(require("@insided/shared/icons/Close"));

var _Warning = _interopRequireDefault(require("@insided/shared/icons/Warning"));

var _Answer = _interopRequireDefault(require("@insided/shared/icons/Answer"));

var _Info = _interopRequireDefault(require("@insided/control/icons/Info"));

var _Forbidden = _interopRequireDefault(require("@insided/control/icons/Forbidden"));

var _InfoV = _interopRequireDefault(require("@insided/control/icons/InfoV2"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var getVariantIcon = function getVariantIcon(variant) {
  switch (variant) {
    case 'success':
      return (0, _preact.h)(_Answer.default, {
        width: 20,
        height: 20
      });

    case 'warning':
      return (0, _preact.h)(_Warning.default, {
        width: 20,
        height: 20
      });

    case 'error':
      return (0, _preact.h)(_Forbidden.default, {
        width: 20,
        height: 20
      });

    case 'info':
      return (0, _preact.h)(_Info.default, {
        width: 20,
        height: 20
      });

    case 'infoV2':
      return (0, _preact.h)(_InfoV.default, {
        width: 20,
        height: 20
      });

    default:
      return (0, _preact.h)(_Answer.default, {
        width: 20,
        height: 20
      });
  }
};

var Message = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Message, _Component);

  var _super = _createSuper(Message);

  function Message(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Message);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "rootElement", null);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "timeoutHandle", 0);
    if (typeof window === 'undefined') return (0, _possibleConstructorReturn2.default)(_this);
    var root = document.querySelector('#message-container');

    if (root) {
      _this.rootElement = root;
      return (0, _possibleConstructorReturn2.default)(_this);
    }

    _this.rootElement = document.createElement('div');
    _this.rootElement.id = 'message-container';
    _this.rootElement.className = 'a-message-container';
    document.body.appendChild(_this.rootElement);
    return _this;
  }

  (0, _createClass2.default)(Message, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      if (this.props.timer) {
        this.timeoutHandle = window.setTimeout(function () {
          return _this2.props.onDismiss();
        }, this.props.timer);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props = this.props,
          _this$props$variant = _this$props.variant,
          variant = _this$props$variant === void 0 ? 'success' : _this$props$variant,
          children = _this$props.children,
          onDismiss = _this$props.onDismiss,
          _this$props$isControl = _this$props.isControl,
          isControl = _this$props$isControl === void 0 ? false : _this$props$isControl,
          _this$props$hideIcon = _this$props.hideIcon,
          hideIcon = _this$props$hideIcon === void 0 ? false : _this$props$hideIcon,
          _this$props$renderHTM = _this$props.renderHTML,
          renderHTML = _this$props$renderHTM === void 0 ? false : _this$props$renderHTM,
          message = _this$props.message;

      if (this.rootElement === null) {
        return null;
      }

      return (0, _preact.h)(_preactPortal.default, {
        into: this.rootElement
      }, (0, _preact.h)("section", {
        className: "a-message a-message--variant-".concat(variant, " ").concat(isControl ? "a-message--insided-".concat(variant) : '')
      }, !hideIcon && (0, _preact.h)("div", {
        className: "a-message--icon a-type-icon a-icon-".concat(variant)
      }, getVariantIcon(variant)), Array(children).toString() !== '' ? (0, _preact.h)("div", {
        className: "a-message--text"
      }, children) : (0, _preact.h)("div", {
        className: "a-message--text-html",
        dangerouslySetInnerHTML: renderHTML && message && typeof message === 'string' ? {
          __html: message
        } : undefined
      }, message), (0, _preact.h)("div", {
        onClick: function onClick() {
          window.clearTimeout(_this3.timeoutHandle);
          onDismiss();
        },
        onKeyDown: function onKeyDown(e) {
          if (e.key === 'Enter' || e.key === ' ') {
            window.clearTimeout(_this3.timeoutHandle);
            onDismiss();
            e.preventDefault();
          }
        },
        role: "button",
        tabIndex: 0,
        "aria-label": "Close message",
        className: "a-message--icon a-icon-close"
      }, (0, _preact.h)(_Close.default, {
        width: 20,
        height: 20
      }))));
    }
  }]);
  return Message;
}(_preact.Component);

var _default = Message;
exports.default = _default;